<template>
  <div>
    <div class="my-6">
      <div class="mx-auto" style="width: 350px">
        <Snooze v-model="timing" :selected_date="timing" pickDefault="next_week" />
      </div>
    </div>
    <div class="modal_footer">
      <a @click="submit()" class="button is-info">Submit</a>
      <div class="my-3 is-size-6 has-text-right is-flex-grow-1">
        id: {{ alert.id }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Snooze from '@/components/Snooze'

export default {
  name: 'FeedAlertEdit',
  components: {
    Snooze
  },
  props: {
    payload: {
      type: Object
    },
    alert: {
      type: Object,
      required: true
    },
    onSubmit: {
      type: Function,
      default: () => ({})
    },
    isSnoozeAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timing: ''
    }
  },
  computed: {
    ...mapGetters('admins', ['getAdminByName'])
  },
  methods: {
    ...mapMutations('modals', ['create', 'removeModalById']),
    async submit () {
      try {
        if (this.isSnoozeAll) {
          // Use -1 as id if alert.id is not available (special value that controller handles)
          await this.$network_utils.massUpdateAlert({
            id: this.alert.id || -1,
            status: 'active',
            timing: this.timing,
            timing_all: 'true'
          })
        } else {
          await this.$network_utils.updateAlert({
            id: this.alert.id,
            status: 'active',
            timing: this.timing
          })
        }
        this.onSubmit(this.payload.modal_id)
      } catch (e) {
        console.log('error: ', e)
      }
    }
  }
}
</script>
